export default __webpack_public_path__ + "static/media/clock.d06222c3.svg";